var EventType = /* @__PURE__ */ ((EventType2) => {
  EventType2["SERVICE_READY"] = "ServiceReady";
  EventType2["ROOM_LOGIN"] = "RoomLogin";
  EventType2["ROOM_CONTAINER_RESIZE"] = "RoomContainerResize";
  EventType2["ROOM_NOTICE_MESSAGE"] = "RoomNoticeMessage";
  EventType2["ROOM_NOTICE_MESSAGE_BOX"] = "RoomNoticeMessageBox";
  EventType2["ROOM_START"] = "RoomStart";
  EventType2["ROOM_JOIN"] = "RoomJoin";
  EventType2["ROOM_LEAVE"] = "RoomLeave";
  EventType2["ROOM_DISMISS"] = "RoomDestroy";
  EventType2["ROOM_ERROR"] = "RoomError";
  EventType2["ROOM_NEED_PASSWORD"] = "RoomNeedPassword";
  EventType2["KICKED_OUT"] = "KickedOut";
  EventType2["KICKED_OFFLINE"] = "KickedOffline";
  EventType2["USER_SIG_EXPIRED"] = "UserSigExpired";
  EventType2["USER_LOGOUT"] = "UserLogout";
  EventType2["LANGUAGE_CHANGED"] = "LanguageChanged";
  EventType2["THEME_CHANGED"] = "ThemeChanged";
  return EventType2;
})(EventType || {});
export {
  EventType
};
